import React from 'react';
import Content from '@/components/foundations/content';
import { StaticImage } from 'gatsby-plugin-image';
import * as styles from './solution.module.scss';

const SolutionContent: React.FC<{modal: Function}> = ({modal}) => {
  const usabilityImage = (
    <figure>
      <StaticImage src="./img/usability.svg" alt="" objectFit="contain" />
    </figure>
  )

  const heuristicImage = (
    <figure>
      <StaticImage src="./img/heuristic10.svg" alt="" objectFit="contain" />
    </figure>
  )

  return (
    <div className={styles.oSolution__message}>
      <h2>
        UIエキスパートレビューは
        <br />
        3つの<strong>効果を生み出します！</strong>
      </h2>
      <p>エキスパートレビューでは、国際規格ISO9241-11にて定義された<strong>インタラクティブシステムのユーザービリティを満たしているか</strong>を、専門家が知識に基づき評価を行います。</p>
      <p><a onClick={() => {modal(usabilityImage);}} href="javascript:void(0);"><span>5つのユーザビリティ</span></a>、<a onClick={() => {modal(heuristicImage);}} href="javascript:void(0);"><span>10ヒューリスティック</span></a>を指標としたレビューと改善案によって、<strong>プロダクトやサービスの質を向上</strong>させます。</p>
      <ul>
        <li>
          <StaticImage src="./img/efficiency.png" alt="業務システムの効率性UP 間違えにくい 一貫性がある・直感的に操作できる" />
        </li>
        <li>
          <StaticImage src="./img/persistency.png" alt="オンラインサービスの継続率UP 使いやすい 操作が簡単・すぐに目的が達成できる" />
        </li>
        <li>
          <StaticImage src="./img/conversion.png" alt="ECサイトのコンバージョンUP 迷わない 選びやすい・すぐ購入できる" />
        </li>
      </ul>
    </div>
  );
};

const Solution: React.FC<{modal: Function}> = ({modal}) => {
  return (
    <Content
      className={{ wrapper: styles.oSolution, inner: styles.lContent__inner }}
      intersection={{ visible: styles.visible, standby: styles.standby }}
    >
      <SolutionContent modal={modal} />
    </Content>
  );
};

export default Solution;
